import * as React from "react";
import { connect } from "react-redux";
import withStyles from "@material-ui/core/styles/withStyles";
import PropTypes from "prop-types";
import { appAction } from "../../actions/app.action";
import { feedAction } from "../../actions/feed.action";
import { portfolioAction } from "../../actions/portfolio.action";
import SectionHeader from "../../components/UI/SectionHeader";
import { householdAction } from "../../actions/household.action";
import Loading from "../../components/Loading/Loading";
import Grid from "@material-ui/core/Grid";

import { FeedCard } from "./components";

const styles = (theme) => ({
  contentWrapper: {
    width: "100%",
    display: `flex`,
    flexDirection: "column",
    paddingBottom: theme.wbiComponent.educationComponent.height + 10,
  },
  contentCaption: {
    marginBottom: 10,
  },
});

class Feed extends React.Component {
  state = {};

  componentDidMount() {
    this.props.dispatch(portfolioAction.clearCurrentPortfolio());
    this.props.dispatch(householdAction.clearCurrentHousehold());
    this.props.dispatch(appAction.setPortfolioNav());
    this.props.dispatch(appAction.toggleMainNav(false));
    window.scrollTo(0, 0);
    this.props.dispatch(feedAction.loadRssFed());
    this.props.dispatch(appAction.setEducationNav(true));
  }

  componentWillUnmount() {
    this.props.dispatch(appAction.setEducationNav(false));
  }

  render() {
    const { classes, feed } = this.props;

    if (!feed.feedData.status) {
      return <Loading />;
    }

    return (
      <div className={classes.contentWrapper}>
        <div className={classes.content}>
          <SectionHeader text={`Cy Intelligence`} />
          <Grid container spacing={3}>
            {feed.feedData.items.map((feed, i) => (
              <FeedCard key={i} feedData={feed} />
            ))}
          </Grid>
        </div>
      </div>
    );
  }
}

Feed.propTypes = {
  classes: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => {
  return {
    app: state.app,
    feed: state.feed,
    appName: state.app.appName,
  };
};
export default withStyles(styles, { withTheme: true })(
  connect(mapStateToProps)(Feed)
);



// WEBPACK FOOTER //
// ./src/containers/Feed/index.jsx